<template>

  <Choose
    :test_work_queue_id="$props.test_work_queue_id"
    :test_work_queue_phase_id="$props.test_work_queue_phase_id"
    :internal_phase_id="$props.internal_phase_id"
    :test_id="$props.test_id"
    :state_slug="$props.state_slug"
    :title="'Scegli il percorso'"
    :prescription="$props.prescription"
    :subtitle="null">
  </Choose>

</template>

<script>
import Choose from "@/components/Iso-in/Choose";

export default {
  name: "IsoInChangeFork",
  inheritAttrs: false,
  props: [
    'test_work_queue_id',
    'test_work_queue_phase_id',
    'internal_phase_id',
    'test_id',
    'state_slug',
    'prescription',
  ],
  components: {
    Choose,
  },
  setup(props) {
    console.log("page: iso in change fork");

    console.log(`state_slug: ${props.state_slug}`);
    console.log(`test_work_queue_id: ${props.test_work_queue_id}`);
    console.log(`test_work_queue_phase_id: ${props.test_work_queue_phase_id}`);
    console.log(`internal_phase_id: ${props.internal_phase_id}`);
    console.log(`test_id: ${props.test_id}`);
  }
}
</script>

